enum ExportsFormats {
  EXCEL = "xlsx",
}

export { ExportsFormats };
